export default [
    {
        name: 'Information',
        subLinks: [
            {
                name: 'Clere Golf Hub',
                route: '/project-manager',
                permission: 'canModuleProjectSG',
            },
            // {
            //     name: 'My Dashboard',
            //     route: '/dashboard',
            //     permission: '*',
            // },
            {
                name: 'Course Manager',
                route: '/course-manager',
                permission: 'canModuleGeoRecord',
            },
            {
                name: 'My Projects',
                route: '/projects',
                permission: 'canModuleProjectSGCustom',
            },
            {
                name: 'Course Measure',
                route: '/course-measure/review',
                permission: 'canModuleCourseMeasurements',
            },
            {
                name: '3D Model',
                route: '/babylon',
                permission: 'canModuleThreeDimension',
            },
            {
                name: 'Flythrough',
                route: '/flythrough',
                permission: 'canModuleFlythroughVideo',
            },
            {
                name: 'Geo Record Projects',
                route: '/geo-record/geo-record-projects',
                permission: 'canModuleGeoRecordProject',
            },
            {
                name: 'Geo Record Archive Events',
                route: '/geo-record/geo-record-archive-events',
                permission: 'canModuleArchiveEvents',
            },
            {
                name: 'Geo Record History',
                route: '/geo-record/geo-record-history',
                permission: 'canModuleGeoRecord',
            },
            // {
            //     name: 'Long Hole View',
            //     route: '/geo-record/long-hole-view',
            //     permission: 'canModuleGeoRecord',
            // },
            {
                name: 'Airtable Integration',
                route: '/airtable',
                permission: 'canModuleAirtable',
            },
            {
                name: 'Buggy Tracking',
                route: '/buggyTracker',
                permission: 'canModuleBuggyTracker',
            },
            {
                name: 'Tutorial Videos',
                route: '/clere-tutorial-videos',
                permission: '*',
            },
            {
                name: 'Location Tracking',
                route: '/location-tracking',
                permission: 'canModuleLocationTracker',
            },
        ],
        route: '',
        permissions: ['*'],
    },
    {
        name: 'Growth Degree Days',
        subLinks: [
            {
                name: 'Treatments',
                route: '/gdd',
                permission: 'canModuleGdd',
            },
            {
                name: 'Products',
                route: '/gdd-products',
                permission: 'canModuleGddProducts',
            },
        ],
        route: '',
        permissions: ['canModuleGdd'],
    },
    {
        name: 'Operations',
        subLinks: [
            {
                name: 'PinZone',
                route: '/pinzone',
                permission: 'canModuleNewPinzone',
            },
            {
                name: 'PinZone Categories',
                route: '/pinzone/categories',
                permission: 'canModuleNewPinzone',
            },
            {
                name: 'PinZone Tables',
                route: '/pinzone/table',
                permission: 'canModulePinzoneTable',
            },
            {
                name: 'Pinzone External Embed',
                route: '/admin/pinzone-external-embed',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Task Manager',
                route: '/task-manager',
                permission: '*',
            },
            // {
            //     name: 'PinZone Greens',
            //     route: '/pinzone/dashboard',
            //     permission: 'canModulePinzone',
            // },
        ],
        route: '',
        permissions: ['canModulePinzone'],
    },
    // {
    //     name: 'Ground2Control',
    //     subLinks: [
    //         {
    //             name: 'Portal',
    //             route: '/ground2control',
    //             permission: 'canModuleGroundControl',
    //         },
    //     ],
    //     route: '',
    //     permissions: [
    //         'canModuleGtcAgrio',
    //         'canModuleGroundControl',
    //         'canModuleGtcCore',
    //         'canModuleGtcPeople',
    //         'canModuleGtcKit',
    //         'canModuleGtcMoney',
    //     ],
    // },

    // None of this is actively used. Commenting out for now.

    // {
    //     name: 'Tournament',
    //     subLinks: [
    //         {
    //             name: 'Live Putt',
    //             route: '/tournament/putt',
    //             permission: 'canEnableAdministrator',
    //         },
    //         {
    //             name: 'Live Putt Grid',
    //             route: '/tournament/putt-grid',
    //             permission: 'canEnableAdministrator',
    //         },
    //         /* {
    //             name: 'Putt Predictor',
    //             route: '/putt',
    //             permission: 'canModuleTournament',
    //         }, */
    //     ],
    //     route: '',
    //     permissions: ['canEnableAdministrator'],
    // },

    {
        name: 'Admin - Projects SG',
        subLinks: [
            {
                name: 'Partner Module Manager',
                route: '/admin/project/partner-module-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Default Module Template Manager',
                route: '/admin/project/default-module-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Category Template Manager',
                route: '/admin/project/category-template-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Clere Products',
                route: '/admin/product/clere-product',
                permission: 'canEnableAdministrator',
            },
        ],
        route: '',
        permissions: ['canEnableAdministrator'],
    },
    {
        name: 'Admin',
        subLinks: [
            {
                name: 'Dashboard',
                route: '/admin/dashboard',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Accounts',
                route: '/admin/accounts',
                permission: 'canEnableOrgAdmin',
            },
            {
                name: 'Organisations',
                route: '/admin/organizations',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Roles',
                route: '/admin/roles',
                permission: 'canEnableOrgAdmin',
            },
            {
                name: 'Geo Record Models',
                route: '/admin/geo-record-models',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Geo Record Category',
                route: '/admin/geo-record-categories',
                permission: 'canEnableOrgAdmin',
            },
            {
                name: 'Geo Record Category Icons',
                route: '/admin/geo-record-category-icons',
                permission: 'canEnableOrgAdmin',
            },
            // {
            //     name: 'Event Log',
            //     route: '/admin/event-logs',
            //     permission: 'canEnableAdministrator',
            // },
            {
                name: 'Course Schemas',
                route: '/admin/course-schemas',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Course Overview',
                route: '/course-overview',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'CAD Import Layers',
                route: '/admin/geo-record-category-custom-layer',
                permission: 'canModuleGeoRecordFileImport',
            },
            {
                name: 'Notification Manager',
                route: '/admin/notification-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Notification Type Editor',
                route: '/admin/notification-type-editor',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Ball Data Harvester',
                route: '/admin/ball-data-harvester',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Pace of Play',
                route: '/admin/pace-of-play',
                permission: 'canModulePaceOfPlay',
            },
            {
                name: 'WHS Manager - Clere Admin',
                route: '/admin/whs-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'Course Companion',
                route: '/admin/course-companion-manager',
                permission: 'canModuleCourseCompanion',
            },
            {
                name: 'WHS Whitelabel Manager',
                route: '/admin/whs-whitelabel-manager',
                permission: 'canEnableAdministrator',
            },
            {
                name: 'PlayerApp Push Notification',
                route: '/admin/app-push-notification',
                permission: 'canEnableOrgAdmin',
            },
        ],
        route: '',
        permissions: ['*'],
    },
];
